"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAllTxRequests = void 0;
const getAllTxRequests = (reqs) => {
    const allTxRequests = reqs
        .map((req, i) => req.txs
        .map((t, i) => {
        return { tx: t, innerIdx: i };
    })
        .map((txWrapper) => {
        if (!Array.isArray(txWrapper.tx))
            return [txWrapper];
        else
            return txWrapper.tx.map((t) => {
                return { tx: t, innerIdx: txWrapper.innerIdx };
            });
    })
        .flat()
        .map((tx) => {
        return {
            tx: tx.tx,
            type: req.type,
            reqIdx: i,
            reqInnerIdx: tx.innerIdx,
        };
    }))
        .flat();
    return allTxRequests;
};
exports.getAllTxRequests = getAllTxRequests;
